export {};
//# sourceMappingURL=transform-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/interfaces/decorator-options/transform-options.interface.js
// module id = 792
// module chunks = 3